import React, {FC} from "react"

import BaseSvgIcon, {type BaseProps} from "../Base"

interface Props extends Omit<BaseProps, "color"> {
  color?: string
}

const Warning: FC<Props> = ({color, ...props}) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 32 32">
      <path
        d="M14.5293 4C15.2991 2.66667 17.2236 2.66667 17.9934 4L29.2517 23.5C30.0215 24.8333 29.0592 26.5 27.5196 26.5H5.00298C3.46338 26.5 2.50113 24.8333 3.27093 23.5L14.5293 4Z"
        fill={color || "#E0AF00"}
      />
      <path
        d="M15.0504 18.3047H17.5504L17.8004 10.7266H14.8004L15.0504 18.3047ZM16.3004 22.2734C17.3082 22.2734 17.902 21.75 17.902 20.8516C17.902 19.9453 17.3082 19.4219 16.3004 19.4219C15.2926 19.4219 14.7067 19.9453 14.7067 20.8516C14.7067 21.75 15.2926 22.2734 16.3004 22.2734Z"
        fill="white"
      />
    </BaseSvgIcon>
  )
}

export default Warning
